import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';

/**
 * Used to break up content
 */
export function Divider(_ref) {
  var _ref$axis = _ref.axis,
      axis = _ref$axis === void 0 ? 'horizontal' : _ref$axis,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'separatorTertiary' : _ref$color,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1 : _ref$size,
      restProps = _objectWithoutPropertiesLoose(_ref, ["axis", "color", "margin", "size"]);

  var props = {
    as: 'div',
    alignSelf: 'stretch',
    backgroundColor: color
  };

  if (axis === 'horizontal') {
    props.height = size + 'px';
    props.marginVertical = margin;
  } else {
    props.width = size + 'px';
    props.marginHorizontal = margin;
  }

  return /*#__PURE__*/React.createElement(Box, _extends({}, props, restProps));
}